<template>
  <pane
    id="filter"
    :title="$t('toolbar.filter.title')"
    :label="$t('toolbar.filter.label')"
    :icon="FilterIcon"
    :highlighted="hasFilters"
  >
    <filter-component v-bind="{ ...$props, ...$attrs }" />
  </pane>
</template>

<script lang="ts" setup>
import Pane from '@components/utils/toolbar/Pane.vue';
import FilterComponent, { type Filter } from '@components/utils/filter/Filter.vue';
import FilterIcon from '@images/panes/filter.svg?component';
import { computed } from 'vue';

export interface Props {
  modelValue?: Record<string, unknown>;
  filters: Filter[];
  page?: number;
}

const props = defineProps<Props>();
const hasFilters = computed(
  () => Object.values(props.modelValue ?? {}).some((value) => value || value === 0 || value === false),
);
</script>

<style lang="scss" scoped></style>
